module.exports = __webpack_public_path__ + "7dfa8f63803d048fad3dc559d523b38c.svg";